import React from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { CardScreen } from './screens/CardScreen.es';
import UpdateProduct from "./components/newproduct/UpdateProductSetting";

function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/" component={CardScreen} />
          <Route exact path="/detail/:detailProductId" component={UpdateProduct} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
